import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, resolveComponent as _resolveComponent, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = { class: "p-6" }
const _hoisted_2 = { class: "mx-auto text-center" }
const _hoisted_3 = { class: "bg-[#01ABC426] bg-opacity-15 border border-[#01ABC4] border-opacity-50 rounded-lg p-12 mb-8" }
const _hoisted_4 = { class: "flex gap-20" }
const _hoisted_5 = { class: "w-44 h-44 my-auto" }
const _hoisted_6 = ["src"]
const _hoisted_7 = { class: "flex-1 text-left" }
const _hoisted_8 = { class: "text-xl font-semibold mb-2" }
const _hoisted_9 = { class: "space-y-2 mt-4" }
const _hoisted_10 = { class: "flex items-center" }
const _hoisted_11 = { class: "font-bold" }
const _hoisted_12 = { class: "flex items-center" }
const _hoisted_13 = { class: "font-bold" }
const _hoisted_14 = { class: "flex items-center" }
const _hoisted_15 = { class: "font-bold" }
const _hoisted_16 = { class: "flex items-center" }
const _hoisted_17 = { class: "font-bold" }
const _hoisted_18 = { class: "flex items-center" }
const _hoisted_19 = { class: "font-bold" }
const _hoisted_20 = { class: "mt-6" }
const _hoisted_21 = ["innerHTML"]
const _hoisted_22 = { class: "mt-6" }
const _hoisted_23 = {
  key: 0,
  class: "w-full rounded-lg shadow-lg",
  controls: "",
  preload: "metadata"
}
const _hoisted_24 = ["src"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Icon = _resolveComponent("Icon")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("div", _hoisted_4, [
          _createElementVNode("div", _hoisted_5, [
            _createElementVNode("img", {
              src: _ctx.sideBarLogo,
              alt: "IqinABox",
              class: "w-full h-full object-fit"
            }, null, 8, _hoisted_6)
          ]),
          _createElementVNode("div", _hoisted_7, [
            _createElementVNode("h4", _hoisted_8, _toDisplayString(_ctx.$t('views.monitoring.unlock.title')), 1),
            _createElementVNode("ul", _hoisted_9, [
              _createElementVNode("li", _hoisted_10, [
                _createVNode(_component_Icon, {
                  src: _ctx.IconSource.Check,
                  class: "w-4 h-4 mr-2 text-blue-600"
                }, null, 8, ["src"]),
                _createElementVNode("span", _hoisted_11, _toDisplayString(_ctx.$t('views.monitoring.unlock.features[0].title')), 1),
                _cache[0] || (_cache[0] = _createElementVNode("span", { class: "mx-1.5" }, "-", -1)),
                _createElementVNode("span", null, _toDisplayString(_ctx.$t('views.monitoring.unlock.features[0].description')), 1)
              ]),
              _createElementVNode("li", _hoisted_12, [
                _createVNode(_component_Icon, {
                  src: _ctx.IconSource.Check,
                  class: "w-4 h-4 mr-2 text-blue-600"
                }, null, 8, ["src"]),
                _createElementVNode("span", _hoisted_13, _toDisplayString(_ctx.$t('views.monitoring.unlock.features[1].title')), 1),
                _cache[1] || (_cache[1] = _createElementVNode("span", { class: "mx-1.5" }, "-", -1)),
                _createElementVNode("span", null, _toDisplayString(_ctx.$t('views.monitoring.unlock.features[1].description')), 1)
              ]),
              _createElementVNode("li", _hoisted_14, [
                _createVNode(_component_Icon, {
                  src: _ctx.IconSource.Check,
                  class: "w-4 h-4 mr-2 text-blue-600"
                }, null, 8, ["src"]),
                _createElementVNode("span", _hoisted_15, _toDisplayString(_ctx.$t('views.monitoring.unlock.features[2].title')), 1),
                _cache[2] || (_cache[2] = _createElementVNode("span", { class: "mx-1.5" }, "-", -1)),
                _createElementVNode("span", null, _toDisplayString(_ctx.$t('views.monitoring.unlock.features[2].description')), 1)
              ]),
              _createElementVNode("li", _hoisted_16, [
                _createVNode(_component_Icon, {
                  src: _ctx.IconSource.Check,
                  class: "w-4 h-4 mr-2 text-blue-600"
                }, null, 8, ["src"]),
                _createElementVNode("span", _hoisted_17, _toDisplayString(_ctx.$t('views.monitoring.unlock.features[3].title')), 1),
                _cache[3] || (_cache[3] = _createElementVNode("span", { class: "mx-1.5" }, "-", -1)),
                _createElementVNode("span", null, _toDisplayString(_ctx.$t('views.monitoring.unlock.features[3].description')), 1)
              ]),
              _createElementVNode("li", _hoisted_18, [
                _createVNode(_component_Icon, {
                  src: _ctx.IconSource.Check,
                  class: "w-4 h-4 mr-2 text-blue-600"
                }, null, 8, ["src"]),
                _createElementVNode("span", _hoisted_19, _toDisplayString(_ctx.$t('views.monitoring.unlock.features[4].title')), 1),
                _cache[4] || (_cache[4] = _createElementVNode("span", { class: "mx-1.5" }, "-", -1)),
                _createElementVNode("span", null, _toDisplayString(_ctx.$t('views.monitoring.unlock.features[4].description')), 1)
              ])
            ]),
            _createElementVNode("div", _hoisted_20, [
              _createElementVNode("div", {
                class: "monitoring-unlock-description",
                innerHTML: _ctx.formattedDescription
              }, null, 8, _hoisted_21)
            ])
          ])
        ])
      ]),
      _createElementVNode("div", _hoisted_22, [
        (_ctx.videoUrl)
          ? (_openBlock(), _createElementBlock("video", _hoisted_23, [
              _createElementVNode("source", {
                src: _ctx.videoUrl,
                type: "video/mp4"
              }, null, 8, _hoisted_24),
              _createElementVNode("p", null, _toDisplayString(_ctx.$t('views.monitoring.unlock.videoNotSupported', 'Your browser does not support the video tag.')), 1)
            ]))
          : _createCommentVNode("", true)
      ])
    ])
  ]))
}